export enum ResourceFavoriteMutationActionType {
  CREATE_FAVORITE_SUCCESS = 'RESOURCE_FAVORITE.CREATE_FAVORITE_SUCCESS',
  REMOVE_FAVORITE_SUCCESS = 'RESOURCE_FAVORITE.REMOVE_FAVORITE_SUCCESS'
}
